import { render, staticRenderFns } from "./ConfirmUpdateTags.vue?vue&type=template&id=5f5b57f0"
import script from "./ConfirmUpdateTags.vue?vue&type=script&lang=js"
export * from "./ConfirmUpdateTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports